//import page from 'page'
import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'

//import Link from '../../components/Link'
//import DangerSvg from '../../components/Icons/Danger'

const LotInfo = ({ startBid, bidStep, startDate, closeDate, currency}) => (
  <section className='Text'>
    <FormattedMessage id='lot.startBid' />: {numeral(startBid).format('0,0')}{currency.symbol}<br></br>
    <FormattedMessage id='lot.bidStep' />: {numeral(bidStep).format('0,0')}{currency.symbol}<br></br>
    <FormattedMessage id='lot.startDate' />: {moment(startDate).format('DD.MM.YYYY')}<br></br>
    <FormattedMessage id='lot.closeDate' />: {moment(closeDate).format('DD.MM.YYYY')}<br></br>
  </section>
)

export default LotInfo


// WEBPACK FOOTER //
// ./src/components/Lot/LotInfo.jsx